import React from "react";
import styles from "./IconButton.module.css";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

const TONES = new Set(["danger", "blue", "green", "neutral"]);
const SIZES = new Set(["sm", "smPlus", "md", "lg"]);

const IconButton = React.forwardRef(function IconButton(
  {
    icon,
    onClick,

    tone = "danger",
    size = "md",

    iconSize = 24,

    disabled = false,
    className,

    type = "button",

    ...props
  },
  ref,
) {
  const resolvedTone = TONES.has(tone) ? tone : "danger";
  const resolvedSize = SIZES.has(size) ? size : "md";

  const iconNode = React.isValidElement(icon)
    ? React.cloneElement(icon, {
        width: iconSize,
        height: iconSize,
      })
    : icon;

  return (
    <button
      {...props}
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={cx(
        styles.btn,
        styles[`tone_${resolvedTone}`],
        styles[`size_${resolvedSize}`],
        disabled ? styles.disabled : "",
        className,
      )}
    >
      <span className={styles.icon}>{iconNode}</span>
    </button>
  );
});

export default IconButton;
